module.exports = __webpack_public_path__ + "img/stone.03741de4.png";